/** Privacy policy (Ley 25.326 de Protección de Datos Personales; Google API Limited Use). */
import type { InfoDoc } from "../types";

export const privacy: InfoDoc = {
  es: {
    title: "Política de privacidad",
    intro:
      "Esta política explica qué datos personales recolecta pokefans.fun, para qué los usa y qué derechos tenés sobre ellos, según la Ley 25.326 de Protección de Datos Personales.",
    sections: [
      {
        title: "1. Responsable",
        paragraphs: [
          "El responsable de tus datos es pokefans.fun, tienda online con base en Argentina. Podés contactarnos en {email}.",
        ],
      },
      {
        title: "2. Qué datos recolectamos",
        paragraphs: [
          "Cuenta: tu nombre, tu email y tu contraseña (guardada cifrada; nunca la vemos).",
          "Ingreso con Google: si elegís \"Continuar con Google\", Google nos comparte tu nombre, tu email y tu foto de perfil. No accedemos a tus contactos, correos, archivos ni a ningún otro dato de tu cuenta de Google.",
          "Pedidos: nombre, email, teléfono, ciudad, forma de entrega, notas y los productos que compraste.",
          "Pagos: los procesan Mercado Pago, Stripe o PayPal. Solo recibimos el resultado del pago y su número de operación; nunca los datos de tu tarjeta.",
          "Vendedores del mercado: si pedís vender, tu fecha de nacimiento, solo para comprobar que sos mayor de 18 años. No es pública.",
          "Arrepentimiento: si usás el botón de arrepentimiento, tu nombre, email, teléfono (opcional), número de pedido y motivo.",
          "Datos técnicos: tu dirección IP y los datos de sesión, para mantenerte conectado, prevenir abusos y limitar intentos de ingreso.",
          "Fotos para identificar cartas: las imágenes que subís en \"Identificar carta\" se procesan solo para reconocer la carta y no se guardan.",
        ],
      },
      {
        title: "3. Para qué los usamos",
        paragraphs: [
          "Para crear y administrar tu cuenta, procesar y entregar tus pedidos, enviarte emails sobre tu cuenta y tus compras, atender consultas y reclamos, proteger el sitio contra fraudes y cumplir obligaciones legales, fiscales y contables.",
          "No vendemos ni alquilamos tus datos, y no los usamos para publicidad.",
        ],
      },
      {
        title: "4. Datos de Google",
        paragraphs: [
          "Usamos los datos que nos da Google (nombre, email y foto de perfil) únicamente para crear tu cuenta e identificarte cuando ingresás. No los transferimos a terceros salvo lo necesario para operar el sitio, no los usamos para publicidad y no los vendemos.",
          "El uso y la transferencia de información recibida de las APIs de Google cumple con la Política de Datos del Usuario de los Servicios de las APIs de Google, incluidos los requisitos de Uso Limitado.",
          "Podés quitarle el acceso a pokefans.fun cuando quieras desde la configuración de seguridad de tu cuenta de Google.",
        ],
      },
      {
        title: "5. Con quién los compartimos",
        paragraphs: [
          "Solo con los proveedores necesarios para operar la tienda, que los tratan por cuenta nuestra: Mercado Pago, Stripe y PayPal (pagos), Resend (envío de emails), Cloudflare (red y seguridad del sitio), Google (si elegís ingresar con Google, y Google Analytics salvo que lo rechaces) y la empresa de correo que entrega tu pedido.",
          "En el [[/mercado/terminos|mercado de la comunidad]], para que se pueda concretar cada compra: le mostramos al vendedor tu nombre y, cuando el pedido está pagado o confirmado, le enviamos a cada parte (por email y en el pedido) el nombre, teléfono y email de la otra, y al vendedor la dirección de entrega si hay envío. Tu tienda, tus publicaciones, tus ventas y calificaciones, y las reseñas que dejás (con tu nombre de pila) son públicas.",
          "También podemos compartirlos si una autoridad competente lo exige por ley.",
        ],
      },
      {
        title: "6. Cookies y almacenamiento local",
        paragraphs: [
          "Usamos una cookie de sesión para mantenerte conectado. En tu navegador guardamos el carrito, el idioma, la moneda elegida y si cerraste el aviso para instalar la app.",
          "Usamos Google Analytics para medir el uso del sitio y de nuestros anuncios en Google; no usamos cookies para mostrarte publicidad. Podés rechazarlo desde el aviso de cookies o desde «Configurar cookies», al pie de cada página. El detalle está en la [[/cookies|política de cookies]].",
        ],
      },
      {
        title: "7. Cuánto tiempo los guardamos",
        paragraphs: [
          "Los datos de tu cuenta, mientras la cuenta exista. Los datos de tus pedidos, durante el plazo que exigen las normas fiscales y contables. Los datos técnicos de seguridad, por períodos cortos.",
        ],
      },
      {
        title: "8. Seguridad",
        paragraphs: [
          "Usamos conexiones cifradas (HTTPS), contraseñas cifradas y acceso restringido a los datos. Ningún sistema es infalible, pero trabajamos para proteger tu información.",
        ],
      },
      {
        title: "9. Tus derechos",
        paragraphs: [
          "Podés pedir acceso a tus datos, rectificarlos, actualizarlos o suprimirlos, y borrar tu cuenta, escribiendo a {email}. Respondemos dentro de los plazos de la Ley 25.326: 10 días corridos para el acceso y 5 días hábiles para la rectificación, actualización o supresión.",
          "El titular de los datos personales tiene la facultad de ejercer el derecho de acceso a los mismos en forma gratuita a intervalos no inferiores a seis meses, salvo que se acredite un interés legítimo al efecto conforme lo establecido en el artículo 14, inciso 3 de la Ley Nº 25.326.",
          "La AGENCIA DE ACCESO A LA INFORMACIÓN PÚBLICA, en su carácter de Órgano de Control de la Ley Nº 25.326, tiene la atribución de atender las denuncias y reclamos que interpongan quienes resulten afectados en sus derechos por incumplimiento de las normas vigentes en materia de protección de datos personales.",
        ],
      },
      {
        title: "10. Menores",
        paragraphs: [
          "El sitio no está dirigido a menores de 13 años y no recolectamos a sabiendas sus datos. Si sos madre, padre o tutor y creés que un menor nos dio datos, escribinos y los borramos.",
        ],
      },
      {
        title: "11. Cambios",
        paragraphs: [
          "Podemos actualizar esta política. La versión vigente es la publicada en esta página, con la fecha de su última actualización. Si el cambio es importante, te avisamos por email.",
        ],
      },
    ],
  },
  en: {
    title: "Privacy policy",
    intro:
      "This policy explains what personal data pokefans.fun collects, what it is used for and your rights over it, under Argentine Law 25,326 on Personal Data Protection.",
    sections: [
      {
        title: "1. Data controller",
        paragraphs: ["Your data is controlled by pokefans.fun, an online store based in Argentina. You can reach us at {email}."],
      },
      {
        title: "2. What data we collect",
        paragraphs: [
          "Account: your name, email and password (stored hashed; we never see it).",
          "Sign in with Google: if you choose \"Continue with Google\", Google shares your name, email address and profile picture with us. We do not access your contacts, emails, files or any other data in your Google account.",
          "Orders: name, email, phone, city, delivery method, notes and the products you bought.",
          "Payments: processed by Mercado Pago, Stripe or PayPal. We only receive the payment result and its transaction id, never your card details.",
          "Market sellers: if you ask to sell, your date of birth, only to check you are 18 or older. It isn't public.",
          "Withdrawals: if you use the withdrawal button, your name, email, phone (optional), order number and reason.",
          "Technical data: your IP address and session data, to keep you signed in, prevent abuse and limit sign-in attempts.",
          "Card identification photos: images you upload in \"Identify a card\" are processed only to recognize the card and are not stored.",
        ],
      },
      {
        title: "3. How we use it",
        paragraphs: [
          "To create and manage your account, process and deliver your orders, email you about your account and purchases, answer questions and complaints, protect the site against fraud and meet legal, tax and accounting obligations.",
          "We do not sell or rent your data, and we do not use it for advertising.",
        ],
      },
      {
        title: "4. Google user data",
        paragraphs: [
          "We use the data Google gives us (name, email and profile picture) only to create your account and identify you when you sign in. We do not transfer it to third parties except as needed to run the site, we do not use it for advertising and we do not sell it.",
          "pokefans.fun's use and transfer of information received from Google APIs adheres to the Google API Services User Data Policy, including the Limited Use requirements.",
          "You can revoke pokefans.fun's access at any time from your Google account's security settings.",
        ],
      },
      {
        title: "5. Who we share it with",
        paragraphs: [
          "Only with the providers needed to run the store, who process it on our behalf: Mercado Pago, Stripe and PayPal (payments), Resend (email delivery), Cloudflare (network and site security), Google (if you sign in with Google, and Google Analytics unless you reject it) and the carrier delivering your order.",
          "In the [[/mercado/terminos|community market]], so each sale can happen: sellers see your name and, once the order is paid or confirmed, each side gets the other's name, phone and email (by email and on the order), and sellers the delivery address when shipping. Your shop, listings, sales, ratings and the reviews you leave (with your first name) are public.",
          "We may also share it when a competent authority requires it by law.",
        ],
      },
      {
        title: "6. Cookies and local storage",
        paragraphs: [
          "We use a session cookie to keep you signed in. Your browser stores your cart, language, chosen currency and whether you dismissed the install-app banner.",
          "We use Google Analytics to measure how the site and our ads on Google are used; we use no cookies to show you ads. You can reject it from the cookie notice or from «Cookie settings» at the bottom of every page. See the [[/cookies|cookie policy]] for details.",
        ],
      },
      {
        title: "7. How long we keep it",
        paragraphs: [
          "Account data, for as long as the account exists. Order data, for the period required by tax and accounting rules. Technical security data, for short periods.",
        ],
      },
      {
        title: "8. Security",
        paragraphs: [
          "We use encrypted connections (HTTPS), hashed passwords and restricted access to data. No system is foolproof, but we work to protect your information.",
        ],
      },
      {
        title: "9. Your rights",
        paragraphs: [
          "You can request access to, correction, update or deletion of your data, and deletion of your account, by writing to {email}. We answer within the terms of Law 25,326: 10 calendar days for access and 5 business days for correction, update or deletion.",
          "You may exercise your right of access free of charge at intervals of no less than six months, unless a legitimate interest is shown (article 14, section 3 of Law 25,326).",
          "The Agencia de Acceso a la Información Pública, as the supervisory authority under Law 25,326, handles complaints from anyone whose data protection rights have been infringed.",
        ],
      },
      {
        title: "10. Children",
        paragraphs: [
          "The site is not directed at children under 13 and we do not knowingly collect their data. If you are a parent or guardian and believe a child gave us data, write to us and we will delete it.",
        ],
      },
      {
        title: "11. Changes",
        paragraphs: [
          "We may update this policy. The version in force is the one on this page, with its last updated date. If the change is significant, we will let you know by email.",
        ],
      },
    ],
  },
};
